
import { defineComponent } from 'vue'

import { AddRepoModal } from '@/components/AddRepo'
import InstallAutofixModal from '@/components/Autofix/Modals/InstallAutofixModal.vue'
import { InviteMembersModal } from '@/components/Members'
import OwnerDetailMixin from '~/mixins/ownerDetailMixin'
import { AppFeatures } from '~/types/permTypes'

interface SetupStep {
  completed: boolean
  shortcode: string
  display_name: string
  description: string
  actions?: Record<string, () => void>
  actionLabel?: string
  icon?: string
  isSupported: boolean
}

export default defineComponent({
  name: 'AccountSetupCard',
  components: {
    AddRepoModal,
    InviteMembersModal,
    InstallAutofixModal
  },
  mixins: [OwnerDetailMixin],
  props: {
    completion: {
      type: Number,
      required: true
    },
    provider: {
      type: String,
      required: true
    }
  },
  async fetch(): Promise<void> {
    await this.fetchAccountSetupStatus({
      login: this.$route.params.owner,
      provider: this.provider
    })
  },
  data() {
    return {
      showAddRepoModal: false,
      showInstallAutofixModal: false
    }
  },
  methods: {
    async refetch(): Promise<void> {
      await this.fetchAccountSetupStatus({
        login: this.$route.params.owner,
        provider: this.provider,
        refetch: true
      })
    },
    getStatus(step: SetupStep): boolean {
      return step.completed
    }
  },
  computed: {
    steps(): Array<SetupStep> | undefined {
      const setupOptions: Record<string, Partial<SetupStep>> = {
        'activate-repository': {
          actions: {
            click: () => {
              this.showAddRepoModal = true
            }
          },
          actionLabel: 'Activate repo',
          icon: 'plus',
          isSupported: true
        },
        'install-autofix': {
          actions: {
            click: () => {
              this.showInstallAutofixModal = true
            }
          },
          actionLabel: 'Install Autofix',
          icon: 'autofix',
          isSupported: this.$gateKeeper.provider(AppFeatures.AUTOFIX, this.provider)
        },
        'invite-team': {
          actionLabel: 'Invite team',
          icon: 'user-plus',
          isSupported: true
        },
        'configure-transformers': {
          actions: {
            click: () => {
              this.showAddRepoModal = true
            }
          },
          actionLabel: 'Setup Code Formatters',
          icon: 'plus',
          isSupported: this.$gateKeeper.provider(AppFeatures.TRANSFORMS, this.provider)
        }
      }

      return (this.owner.accountSetupStatus as Array<SetupStep>)
        .filter((step) => {
          const { isSupported } = setupOptions[step.shortcode]

          return isSupported
        })
        .map((step) => {
          return Object.assign(JSON.parse(JSON.stringify(step)), setupOptions[step.shortcode])
        })
    }
  }
})
